import { useQuery } from '@tanstack/react-query'

import { fetchStore } from '../api'

const useStore = () => {
  return useQuery({
    queryKey: ['store'],
    queryFn: fetchStore,
  })
}

export default useStore
